import { createContext, useContext } from "react"

import { PreviewModeContextValue } from "./PreviewMode.types"

export const PreviewModeContext = createContext<PreviewModeContextValue | undefined>(undefined)

export function usePreviewMode() {
    const ctx = useContext(PreviewModeContext)
    if (!ctx) {
        throw new Error("usePreviewMode must be used within a PreviewModeProvider")
    }
    return ctx
}
